export default __webpack_public_path__ + "static/media/badrinath.8ef3d6b9.jpg";